import {astStore, dataStore, renderStore, commonStore, userStore} from "../index";
import {ConfigAST, DataSources, PureFunctionSetting} from "../ast/ast.types";
import {Paging, RenderDataSource as RenderDataSourceClass} from "../data/data.types";
import {isDeepStrictEqual, updateStatusObj} from "../../utils";
import {attrWatchHandler} from "../../utils/functionParser/functionImpl/componentStoreFunctionImpl";
import {findAllData} from "../../utils/dataSourceQuery";
import {genRuntimeDynamicCss, parseTailwindToCss} from '../../utils/tailwindcss';
import {setKeyValue} from "./localStorageManager";
import {User} from "../user/user.types";
import {canvasGlobal} from "../../layout/canvasGlobal";


/**
 * @description:
 * @return {*}
 */
export function setUser(user: User) {
  for (let key in user) {
    if (user[key]) {
      userStore.state[key] = user[key];
      setKeyValue(key, user[key]);
    }
  }
}

export function setMsgReg(val) {
  commonStore.state.msgReg = val;
}


/**
 * @description: 设计态-set整个AST
 * @return {*}
 */
export function setConigAST(ast: ConfigAST) {
  for (let key in ast) {
    astStore.state[key] = ast[key];
  }
}

/**
 * @description: 设计态-获取整个AST
 * @return {*}
 */
export function getConigAST() {
  let ast = new ConfigAST();
  for (let key in ast) {
    ast[key] = _get(astStore.state, key)
  }
  return ast;
}

/**
 * @description: 设计态-更新数据源
 * @param {DataSources} val
 * @return {*}
 */
export function updateDataSources(val: DataSources) {
  astStore.state.dataSources = val;
}

/**
 * @description: 设计态-获取单个组件对象
 * @return {*}
 * @param prop
 */
export function getASTComponent(prop: string) {
  const index = astStore.state.components.findIndex(comp => comp.prop === prop)
  if (index > -1) {
    return astStore.state.components[index]
  }
}

/**
 * @description: 设计态-更新指定组件
 * @param {ComponentItem} val
 * @return {*}
 */
export function updateASTComponentItem(val: ComponentItem) {
  astStore.updateComponent(val);
}

/**
 * @description: 设计态-更新组件的指定属性
 * @param {ComponentItem} data
 * @param {*} key
 * @param {*} val
 * @return {*}
 */
export function updateASTComponentProp(data: ComponentItem, key, val) {
  // 批量处理选择组件的样式
  let components = _cloneDeep(astStore.state.components);
  // // 遍历值
  for (let item of canvasGlobal.componentsSelected) {
    if (item != data.prop && item != "root") {
      let component = components.find(component => component.prop === item);
      _set(component, key, val);
      astStore.updateComponent(component);
    }
  }
  _set(data, key, val);
  astStore.updateComponent(data);
  console.info("updateASTComponentProp", key, val, data);
}

export function getASTComponentById(prop: string) {
  return astStore.state.components.find(comp => comp.prop === prop);
}

/**
 * @description: 设计态-更新单个组件对象
 * @param {ComponentItem} data
 * @param {*} key
 * @param {*} val
 * @return {*}
 */
export function updateASTComponent(data: ComponentItem) {
  const index = astStore.state.components.findIndex(comp => comp.prop === data.prop)
  console.log(index);

  const arr = updateStatusObj(astStore.state.components, data, index);
  console.log(arr);

  updateASTComponents(arr)
}

/**
 * @description: 设计态-更新组件的自定义属性的值
 * @param {ComponentItem} data
 * @param {*} key
 * @param {*} val
 * @return {*}
 */
export function updateASTComponentAttr(data: ComponentItem, attr, val) {
  let preVal = _get(data.attrs, `${attr}.value`);
  if (isDeepStrictEqual(preVal, val)) return;
  _set(data.attrs, `${attr}.value`, val);
  astStore.updateComponent(data);
  console.log("updateASTComponentAttr", data);
}

/**
 * @description: 设计态-更新AST上的组件
 * @param {ComponentItem} val
 * @return {*}
 */
export function updateASTComponents(val: ComponentItem[]) {
  console.info("updateASTComponents", val);
  astStore.state.components = val;
}


/**
 * @description: 设计态-更新AST上的事件纯函数
 * @param {ComponentItem} val
 * @return {*}
 */
export function updateASTPureFunction(val: PureFunctionSetting) {
  console.info("updateASTPureFunction", val);
  astStore.state.pureFunction = val;
}


/**
 * 设计态 将所有的组件tailwindcss 转成标准css
 * @param components
 */
export function updateAstComponentsTailwindToCss(components: ComponentItem[]) {
  for (let component of components) {
    if (_get(component, 'dynamicCss[0].sources[0].css.css_default')) {
      const style_css = parseTailwindToCss(component.dynamicCss[0].sources[0].css.normal);
      const defaultPathPrefix = 'dynamicCss[0].sources[0].css.css_default';
      _set(component, `${defaultPathPrefix}`, style_css)
    }
  }
}


/**
 * @description: 设计态-更新AST上的某个外层属性
 * @param {string} key
 * @param {any} val
 * @return {*}
 */
export function updateASTProp(key: string, val: any) {
  astStore.updateProp(key, val);
}


/**
 * @description: 设计态-更新当前选中的组件
 * @param {string} id
 * @return {*}
 */
export function updateSeletedId(id: string) {
  commonStore.state.selectedId = id;
}


/**
 * @description: 渲染态- 获取指定实例的配置树
 * @param {string} instanceId
 * @return {*}
 */
export function getConfigByInstanceId(instanceId: string) {
  return dataStore.state.instanceConfig.get(instanceId);
}


/**
 * @description: 渲染态- 获取配置树的指定组件
 * @param {string} instanceId
 * @param {string} prop
 * @return {*}
 */
export function getConfigComponentById(instanceId: string, prop: string) {
  let config = dataStore.state.instanceConfig.get(instanceId);
  return config.components.find(it => it.prop === prop);
}


/**
 * @description: 渲染态- 获取指定实例的整个渲染树
 * @param {string} instanceId
 * @return {*}
 */
export function getRenderComponentsById(instanceId: string) {
  return renderStore.state.instanceTree.get(instanceId);
}


/**
 * @description: 渲染态- 获取渲染树的指定组件
 * @param {string} instanceId
 * @param {string} prop
 * @return {*}
 */
export function getRenderComponentById(instanceId: string, prop: string) {
  return renderStore.state.instanceTree.get(instanceId).get(prop);
}


/**
 * @description:渲染态-  更新指定实例的整个渲染树
 * @param {string} instanceId
 * @param {Map} val
 * @param {*} any
 * @return {*}
 */
export function setRenderComponentsById(instanceId: string, val: Map<string, any>) {
  renderStore.state.instanceTree.set(instanceId, val);
}


/**
 * @description: 渲染态- 更新渲染树的指定组件
 * @param {string} instanceId
 * @param {string} prop
 * @param {*} component
 * @return {*}
 */
export function setRenderComponentById(instanceId: string, prop: string, component) {
  let tree = renderStore.state.instanceTree.get(instanceId);
  if (!tree) {
    tree = new Map();
  }
  tree.set(prop, component);
  commonStore.state.reRender = {prop, instanceId};
}

/**
 * @description: 渲染态- 更新渲染树的循环区域组件不触发重新渲染
 * @param {string} instanceId
 * @param components
 * @return {*}
 */
export function setRenderComponents(instanceId: string, components: any) {
  let tree = renderStore.state.instanceTree.get(instanceId)
  if (components.length > 0) {
    for (let i = 1; i < components.length; i++) {
      if (!tree) {
        tree = new Map();
      }
      tree.set(components[i].prop, components[i]);
    }
    renderStore.state.instanceTree.set(instanceId, tree);
    return components[0]
  }

}


/**
 * @description: 渲染态- 更新渲染树的组件不触发重新渲染
 * @param {string} instanceId
 * @param components
 * @return {*}
 */
export function addRenderComponents(instanceId: string, components: any) {
  let tree = renderStore.state.instanceTree.get(instanceId)
  if (components.length > 0) {
    for (let i = 0; i < components.length; i++) {
      if (!tree) {
        tree = new Map();
      }
      tree.set(components[i].prop, components[i]);
    }
    renderStore.state.instanceTree.set(instanceId, tree);
  }

}

/**
 * 渲染态- 更新渲染树的组件属性不触发重新渲染
 * @param instanceId
 * @param prop
 * @param component
 */
export function updateRenderComponentById(instanceId: string, prop: string, component) {
  let tree = renderStore.state.instanceTree.get(instanceId)
  if (!tree) {
    tree = new Map();
  }
  tree.set(prop, component);
  renderStore.state.instanceTree.set(instanceId, tree);
}

/**
 * @description: 渲染态- 删除渲染树的指定组件
 * @param {string} instanceId
 * @param {string} prop
 * @return {*}
 */
export function deleteRenderComponentById(instanceId: string, prop: string) {
  let tree = renderStore.state.instanceTree.get(instanceId);
  tree.delete(prop);
  setRenderComponentsById(instanceId, tree);
}

/**
 * 删除指定实例
 * @param instanceId
 */
export function deleteRenderComponents(instanceId: string) {
  renderStore.state.instanceTree.delete(instanceId);
}

/**
 * @description: 渲染态- 拉取数据后 更新指定数据源数据 - 不触发onChange
 * @param {string} instanceId
 * @param {string} prop
 * @param {any} renderData
 * @return {*}
 */
export function setRenderDataSource(instanceId: string, prop: string, renderData: any) {
  let instanceData = dataStore.state.instanceData.get(instanceId)
  if (!instanceData) {
    instanceData = new Map()
  }
  instanceData.set(prop, renderData);
  dataStore.state.instanceData.set(instanceId, instanceData);
  commonStore.state.dataLoader = {instanceId, prop, renderData: {...renderData}}
}


/**
 * @description: 渲染态- 获取指定数据源的数据
 * @param {string} instanceId
 * @param {*} dataSource
 * @return {*}
 */
export function getRenderDataSource(instanceId: string, dataSource) {
  let data = new RenderDataSourceClass();
  if (instanceId && dataSource) {
    let instanceData = dataStore.state.instanceData.get(instanceId)
    data = instanceData.get(dataSource);
  }
  return data;
}


/**
 * @description: 渲染态-更新组件的指定属性
 * @param instanceId
 * @param {ComponentItem} data
 * @param attrName
 * @param {*} val
 * @return {*}
 */
export async function updateRenderComponentAttr(instanceId, data: any, attrName, val) {
  data = getRenderComponentById(instanceId, data.prop);
  let preVal = _get(data.attrs, [attrName, 'value']);
  if (isDeepStrictEqual(preVal, val)) return;
  _set(data.attrs, [attrName, 'value'], val);
  // 查找AST中当前修改的属性中标的匹配规则对应的样式，然后合并.
  data.dynamicCss = genRuntimeDynamicCss(_cloneDeep(data.dynamicCss), attrName, val, data);

  await attrWatchHandler(data, attrName, instanceId);
  setRenderComponentById(instanceId, data.prop, data);

  console.info("updateRenderComponentAttr", attrName, val, _cloneDeep(data));
}


/**
 * @description: 渲染态-更新组件的指定属性不触发change和监听
 * @param instanceId
 * @param {ComponentItem} data
 * @param attrName
 * @param {*} val
 * @return {*}
 */
export async function updateRenderCompAttr(instanceId: string, data: any, attrName: string, val: any) {
  data = getRenderComponentById(instanceId, data.prop);
  if (data && data.attrs){
    let preVal = _get(data?.attrs, [attrName, 'value']);
    if (isDeepStrictEqual(preVal, val)) return;
    _set(data.attrs, [attrName, 'value'], val);
    updateRenderComponentById(instanceId, data.prop, data);
  }
}


/**
 * @description: 渲染态-更新分页-重新拉取数据
 * @param {string} instanceId
 * @param {string} prop
 * @param {Paging} paging
 * @return {*}
 */
export async function setRenderPaging(instanceId: string, prop: string, paging: Paging) {
  let instanceData = dataStore.state.instanceData.get(instanceId)
  if (!instanceData) {
    instanceData = new Map()
  }
  let renderData = instanceData.get(prop);
  _set(renderData, ['paging'], paging)
  instanceData.set(prop, renderData);
  dataStore.state.instanceData.set(instanceId, instanceData);
  let dataSources = getConfigByInstanceId(instanceId).dataSources;
  findAllData(instanceId, dataSources, instanceData)
}


/**
 * 设置指定数据源分页
 * @param instanceId
 * @param prop 数据源
 * @param paging
 */
export function setRenderDataSourcePaging(instanceId: string, prop: string, paging: Paging) {
  let instanceData = dataStore.state.instanceData.get(instanceId)
  if (!instanceData) {
    instanceData = new Map()
  }
  let renderData = instanceData.get(prop);
  _set(renderData, ['paging'], paging)
  instanceData.set(prop, renderData);
  dataStore.state.instanceData.set(instanceId, instanceData);
}


/**
 * 数据选择属性映射
 * @param rowData
 * @param componentData
 * @param instanceId
 */
export async function componentAttrsMapping(rowData: any, componentData: any, instanceId: string) {
  if (_size(rowData) > 0) {
    for (const datum of rowData) {
      for (const key of Object.keys(componentData.attrs)) {
        if (datum[key]) {
          await updateRenderCompAttr(instanceId, componentData, key, datum[key]);
          if (_has(componentData, ['attrs', 'textValue'])) {
            const value = _get(datum, `view_${key}`, _get(datum, key));
            await updateRenderComponentAttr(instanceId, componentData, 'textValue', value);
          }
        }
      }
    }
  }
}
